<template lang="html">
  <div v-if="res">
    <div>
      <div :style="(acc > 30 ? 'color: var(--error-color);' : '') + ' font-size: 120%; margin: 20px 0;'">
        <h2 v-if="acc > 30">Attenzione!</h2>
        <br>
        L'aps che ha partita IVA non può superare il <b>50%</b> delle entrate di natura commerciale.
        <br>
        Totale entrate: <b>{{ $n(res.entrate, 'currency') }}</b>
        <br>
        Totale entrate di natura commerciale: <b>{{ $n(-res.accessorie, 'currency') }}</b>
        <br>
        Percentuale entrate di natura commerciale: <b>{{ (acc || 0).toFixed(2) }}%</b>
        <br>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['year'],
  data() {
    return {
      loading: true,
      res: null,
    }
  },

  mounted() {
    setTimeout(() => {
      this.refreshEntrateVsAccessorie()
    }, 100)
    this.$root.$on('transactions', this.refreshEntrateVsAccessorie)
  },
  beforeDestroy() {
    this.$root.$off('transactions', this.refreshEntrateVsAccessorie)
  },



  methods: {
    refreshEntrateVsAccessorie () {
      if (!this.$store.company.has_iva) return
      this.$http.get(`entrate-vs-accessorie/${this.$store.company.id}/${this.year}`).then(res => {
        this.res = res.data
      })
    }
  },

  computed: {
    acc () {
      if (!this.res) return 0
      return -this.res.accessorie/this.res.entrate * 100
    },
  },
}
</script>

<style lang="css">
</style>
